import axios from 'axios';
import { DEVELOPMENT, ENVIRONMENT } from 'constants';
import { IG_NOTIFICATION_URL } from 'constants';
import { Store } from 'react-notifications-component';
import { getAuthorizationToken } from 'services/authorization_token';
import { getCurrentSubDomain } from 'services/sub_domain';

export class ErrorNotification {
  constructor({ message, requestId, userId, userEmail }) {
    this.message = message;
    this.requestId = requestId;
    this.brand = getCurrentSubDomain();
    this.userId = userId;
    this.userEmail = userEmail;
    this.errorLocation = window.location.href;
    this.environment = ENVIRONMENT;
  }
  getNotification() {
    return {
      title: `:warning: [FRONT] - Application Error in ${this.environment}`,
      messages: [
        `*Message* : ${this.message}`,
        `*Request ID* : ${this.requestId}`,
        `*Brand* : ${this.brand}`,
        `*User ID* : ${this.userId}`,
        `*User email* : ${this.userEmail}`,
        `*Error location* : ${this.errorLocation}`,
      ],
    };
  }
}

export const notifyIG = ({ title, messages = [] }) => {
  if (DEVELOPMENT) {
    return;
  }
  return axios.post(
    IG_NOTIFICATION_URL,
    {
      text: title,
      blocks: messages.map((message) => ({
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: message,
        },
      })),
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthorizationToken()}`,
      },
    },
  );
};

const notify = ({ type = 'info', message, title = null, ...options }) => {
  Store.addNotification({
    title,
    message,
    type: type,
    insert: 'top',
    container: 'top-right',
    width: 350,
    dismiss: {
      duration: 2000,
      onScreen: false,
    },
    ...options,
  });
};

export default notify;
